(function () {
  if (window.RawAuraCommerce) return;

  const WISHLIST_KEY = 'rawAuraWishlistV1';


  /* =========================================================
     基础
  ========================================================= */

  function rootUrl() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }


  /* =========================================================
     Wishlist
  ========================================================= */

  function getWishlist() {
    try {
      const stored =
        localStorage.getItem(
          WISHLIST_KEY
        );

      if (!stored) {
        return [];
      }

      const parsed =
        JSON.parse(stored);

      if (!Array.isArray(parsed)) {
        return [];
      }

      return [
        ...new Set(
          parsed.filter(Boolean)
        )
      ];

    } catch (error) {
      return [];
    }
  }


  function saveWishlist(items) {

    const cleanItems = [
      ...new Set(
        items.filter(Boolean)
      )
    ];


    try {

      localStorage.setItem(
        WISHLIST_KEY,
        JSON.stringify(
          cleanItems
        )
      );

    } catch (error) {

      console.warn(
        'Raw Aura wishlist could not be saved.',
        error
      );

    }


    window.dispatchEvent(
      new CustomEvent(
        'raw-aura:wishlist-changed',
        {
          detail: {
            items:
              cleanItems,

            count:
              cleanItems.length
          }
        }
      )
    );


    syncWishlistButtons();


    return cleanItems;
  }


  function isWishlisted(handle) {
    return getWishlist().includes(handle);
  }


  function addWishlist(handle) {

    const wishlist =
      getWishlist();


    if (
      !wishlist.includes(handle)
    ) {
      wishlist.push(handle);
    }


    return saveWishlist(
      wishlist
    );
  }


  function removeWishlist(handle) {

    const wishlist =
      getWishlist().filter(
        item =>
          item !== handle
      );


    return saveWishlist(
      wishlist
    );
  }


  function toggleWishlist(handle) {

    if (!handle) {
      return false;
    }


    if (
      isWishlisted(handle)
    ) {

      removeWishlist(handle);

      return false;
    }


    addWishlist(handle);

    return true;
  }


  function syncWishlistButtons(
    scope = document
  ) {

    scope
      .querySelectorAll(
        '[data-ra-wishlist]'
      )
      .forEach(button => {

        const handle =
          button.dataset.productHandle;


        if (!handle) {
          return;
        }


        const active =
          isWishlisted(handle);


        button.classList.toggle(
          'is-active',
          active
        );


        button.setAttribute(
          'aria-pressed',
          active
            ? 'true'
            : 'false'
        );


        button.setAttribute(
          'aria-label',
          active
            ? 'Remove from wishlist'
            : 'Add to wishlist'
        );

      });

  }


  /* =========================================================
     Horizon Header Section ID
  ========================================================= */

  function getHeaderSectionId() {

    const cartIcon =
      document.querySelector(
        'cart-icon[data-testid="cart-icon"], cart-icon.header-actions__cart-icon'
      );


    if (!cartIcon) {
      return null;
    }


    const section =
      cartIcon.closest(
        '.shopify-section[id^="shopify-section-"]'
      );


    if (
      !section ||
      !section.id
    ) {
      return null;
    }


    return section.id.replace(
      /^shopify-section-/,
      ''
    );

  }


  /* =========================================================
     HTML Parser
  ========================================================= */

  function parseHtml(html) {

    if (!html) {
      return null;
    }


    const parser =
      new DOMParser();


    return parser.parseFromString(
      html,
      'text/html'
    );

  }


  /* =========================================================
     更新 Header Cart Icon
  ========================================================= */

  function replaceHeaderCartIcon(
    html
  ) {

    const parsed =
      parseHtml(html);


    if (!parsed) {
      return false;
    }


    const freshIcons = [
      ...parsed.querySelectorAll(
        'cart-icon[data-testid="cart-icon"], cart-icon.header-actions__cart-icon'
      )
    ];


    const currentIcons = [
      ...document.querySelectorAll(
        'cart-icon[data-testid="cart-icon"], cart-icon.header-actions__cart-icon'
      )
    ];


    if (
      freshIcons.length === 0 ||
      currentIcons.length === 0
    ) {
      return false;
    }


    currentIcons.forEach(
      (
        currentIcon,
        index
      ) => {

        const sourceIcon =
          freshIcons[index] ||
          freshIcons[0];


        if (!sourceIcon) {
          return;
        }


        const replacement =
          document.importNode(
            sourceIcon,
            true
          );


        /*
         * 确保 Horizon 原生购物车数字动画
         * 不会被触发。
         */

        const bubble =
          replacement.querySelector(
            '.cart-bubble'
          );


        if (bubble) {

          bubble.classList.remove(
            'cart-bubble--animating'
          );

        }


        currentIcon.replaceWith(
          replacement
        );

      }
    );


    return true;
  }


  /* =========================================================
     更新 Cart Drawer
  ========================================================= */

  function replaceCartDrawer(
    html
  ) {

    const parsed =
      parseHtml(html);


    if (!parsed) {
      return false;
    }


    const currentWrapper =
      document.getElementById(
        'shopify-section-cart-drawer-section'
      );


    const currentDrawer =
      document.getElementById(
        'cart-drawer'
      );


    const currentDialog =
      currentDrawer
        ? currentDrawer.querySelector(
            'dialog'
          )
        : null;


    const wasOpen =
      Boolean(
        currentDialog &&
        currentDialog.open
      );


    const freshWrapper =
      parsed.getElementById(
        'shopify-section-cart-drawer-section'
      );


    const freshDrawer =
      parsed.getElementById(
        'cart-drawer'
      );


    let replaced =
      false;


    /*
     * 优先整个 section 替换
     */

    if (
      currentWrapper &&
      freshWrapper
    ) {

      const replacement =
        document.importNode(
          freshWrapper,
          true
        );


      currentWrapper.replaceWith(
        replacement
      );


      replaced =
        true;

    }


    /*
     * 没有 wrapper 时
     * 直接替换 cart drawer
     */

    else if (
      currentDrawer &&
      freshDrawer
    ) {

      const replacement =
        document.importNode(
          freshDrawer,
          true
        );


      currentDrawer.replaceWith(
        replacement
      );


      replaced =
        true;

    }


    /*
     * 如果更新前购物车抽屉已经打开，
     * 更新后继续保持打开。
     */

    if (
      replaced &&
      wasOpen
    ) {

      requestAnimationFrame(
        () => {

          const newDrawer =
            document.getElementById(
              'cart-drawer'
            );


          const newDialog =
            newDrawer
              ? newDrawer.querySelector(
                  'dialog'
                )
              : null;


          if (
            newDialog &&
            !newDialog.open
          ) {

            try {

              newDialog.showModal();

            } catch (error) {

              newDialog.setAttribute(
                'open',
                ''
              );

            }

          }

        }
      );

    }


    return replaced;
  }


  /* =========================================================
     Cart Live Region
  ========================================================= */

  function updateCartLiveRegion(
    cart
  ) {

    if (!cart) {
      return;
    }


    const itemCount =
      Number(
        cart.item_count || 0
      );


    document
      .querySelectorAll(
        '[data-testid="cart-count-live-region"]'
      )
      .forEach(region => {

        region.textContent =
          itemCount === 1
            ? '1 item in cart'
            : `${itemCount} items in cart`;

      });

  }


  /* =========================================================
     Cart Count Fallback
  ========================================================= */

  function syncCartCountFallback(
    cart
  ) {

    if (!cart) {
      return;
    }


    const itemCount =
      Number(
        cart.item_count || 0
      );


    const displayCount =
      itemCount > 99
        ? '99+'
        : itemCount > 0
          ? String(itemCount)
          : '';


    document
      .querySelectorAll(
        'cart-icon'
      )
      .forEach(cartIcon => {

        const countElement =
          cartIcon.querySelector(
            '.cart-bubble__text-count'
          );


        if (countElement) {

          countElement.textContent =
            displayCount;

        }


        /*
         * Horizon 需要这个 class
         * 来正确给购物车 SVG 留出数字位置。
         */

        cartIcon.classList.toggle(
          'header-actions__cart-icon--has-cart',
          itemCount > 0
        );


        /*
         * 但是不要任何 grow 动画。
         */

        const bubble =
          cartIcon.querySelector(
            '.cart-bubble'
          );


        if (bubble) {

          bubble.classList.remove(
            'cart-bubble--animating'
          );


          /*
           * 同时取消可能还在运行的动画。
           */

          if (
            typeof bubble.getAnimations ===
            'function'
          ) {

            bubble
              .getAnimations()
              .forEach(
                animation => {

                  try {

                    animation.cancel();

                  } catch (error) {
                  }

                }
              );

          }

        }

      });

  }


  /* =========================================================
     清除所有购物车数字动画
  ========================================================= */

  function removeCartBubbleAnimations() {

    document
      .querySelectorAll(
        'cart-icon .cart-bubble'
      )
      .forEach(bubble => {

        bubble.classList.remove(
          'cart-bubble--animating'
        );


        if (
          typeof bubble.getAnimations ===
          'function'
        ) {

          bubble
            .getAnimations()
            .forEach(
              animation => {

                try {

                  animation.cancel();

                } catch (error) {
                }

              }
            );

        }


        /*
         * 清除可能残留的 inline 动画状态
         */

        bubble.style.transform =
          '';

        bubble.style.opacity =
          '';

      });

  }


  /* =========================================================
     Cart
  ========================================================= */

  async function getCart() {

    const response =
      await fetch(
        `${rootUrl()}cart.js`,
        {

          method:
            'GET',

          headers: {
            Accept:
              'application/json'
          },

          credentials:
            'same-origin'

        }
      );


    if (!response.ok) {

      throw new Error(
        'Unable to retrieve cart.'
      );

    }


    return await response.json();

  }


  /* =========================================================
     Shopify Section Rendering fallback
  ========================================================= */

  async function fetchSections(
    sectionIds
  ) {

    const validIds =
      sectionIds.filter(Boolean);


    if (
      validIds.length === 0
    ) {
      return {};
    }


    const url =
      new URL(
        window.location.href
      );


    url.search =
      '';

    url.hash =
      '';


    url.searchParams.set(
      'sections',
      validIds.join(',')
    );


    const response =
      await fetch(
        url.toString(),
        {

          method:
            'GET',

          headers: {
            Accept:
              'application/json'
          },

          credentials:
            'same-origin'

        }
      );


    if (!response.ok) {
      return {};
    }


    try {

      return await response.json();

    } catch (error) {

      return {};

    }

  }


  /* =========================================================
     应用 Shopify 返回的 Sections
  ========================================================= */

  function applyRenderedSections(
    sections,
    headerSectionId
  ) {

    const result = {

      drawer:
        false,

      header:
        false

    };


    if (!sections) {
      return result;
    }


    const drawerHtml =
      sections[
        'cart-drawer-section'
      ];


    if (drawerHtml) {

      result.drawer =
        replaceCartDrawer(
          drawerHtml
        );

    }


    if (
      headerSectionId &&
      sections[
        headerSectionId
      ]
    ) {

      result.header =
        replaceHeaderCartIcon(
          sections[
            headerSectionId
          ]
        );

    }


    return result;
  }


  /* =========================================================
     Add Variant
  ========================================================= */

  async function addVariant(
    variantId,
    quantity = 1
  ) {

    if (!variantId) {

      throw new Error(
        'Missing variant ID.'
      );

    }


    const headerSectionId =
      getHeaderSectionId();


    const requestedSections = [
      'cart-drawer-section'
    ];


    if (
      headerSectionId &&
      !requestedSections.includes(
        headerSectionId
      )
    ) {

      requestedSections.push(
        headerSectionId
      );

    }


    const payload = {

      items: [
        {

          id:
            Number(
              variantId
            ),

          quantity:
            Number(
              quantity
            )

        }
      ],

      sections:
        requestedSections,

      sections_url:
        window.location.pathname

    };


    const response =
      await fetch(
        `${rootUrl()}cart/add.js`,
        {

          method:
            'POST',

          headers: {

            Accept:
              'application/json',

            'Content-Type':
              'application/json',

            'X-Requested-With':
              'XMLHttpRequest'

          },

          credentials:
            'same-origin',

          body:
            JSON.stringify(
              payload
            )

        }
      );


    if (!response.ok) {

      let message =
        'Unable to add this product to cart.';


      try {

        const errorData =
          await response.json();


        message =
          errorData.description ||
          errorData.message ||
          message;

      } catch (error) {
      }


      throw new Error(
        message
      );

    }


    const addResult =
      await response.json();


    /*
     * 使用 Shopify bundled section rendering。
     */

    let renderState =
      applyRenderedSections(
        addResult.sections || {},
        headerSectionId
      );


    /*
     * 如果某个 Section 没返回，
     * 再单独请求。
     */

    if (
      !renderState.drawer ||
      (
        headerSectionId &&
        !renderState.header
      )
    ) {

      const fallbackIds =
        [];


      if (
        !renderState.drawer
      ) {

        fallbackIds.push(
          'cart-drawer-section'
        );

      }


      if (
        headerSectionId &&
        !renderState.header
      ) {

        fallbackIds.push(
          headerSectionId
        );

      }


      if (
        fallbackIds.length > 0
      ) {

        const fallbackSections =
          await fetchSections(
            fallbackIds
          );


        const fallbackState =
          applyRenderedSections(
            fallbackSections,
            headerSectionId
          );


        renderState = {

          drawer:
            renderState.drawer ||
            fallbackState.drawer,

          header:
            renderState.header ||
            fallbackState.header

        };

      }

    }


    /*
     * 获取最终购物车数据
     */

    const cart =
      await getCart();


    /*
     * Header Section 更新失败时
     * 才使用 fallback。
     */

    if (
      !renderState.header
    ) {

      syncCartCountFallback(
        cart
      );

    }


    updateCartLiveRegion(
      cart
    );


    /*
     * 关键：
     *
     * 完全取消购物车数字动画。
     *
     * 不放大
     * 不缩小
     * 不淡入
     * 不 grow
     *
     * 数字直接出现。
     */

    removeCartBubbleAnimations();


    /*
     * 通知其他 Raw Aura 模块
     */

    window.dispatchEvent(
      new CustomEvent(
        'raw-aura:cart-updated',
        {
          detail: {
            cart
          }
        }
      )
    );


    document.dispatchEvent(
      new CustomEvent(
        'raw-aura:cart-added',
        {
          detail: {
            cart
          }
        }
      )
    );


    return cart;

  }


  /* =========================================================
     Add Form
  ========================================================= */

  async function addForm(
    form
  ) {

    const variantInput =
      form.querySelector(
        '[name="id"]'
      );


    const quantityInput =
      form.querySelector(
        '[name="quantity"]'
      );


    const variantId =
      variantInput
        ? variantInput.value
        : null;


    const quantity =
      quantityInput
        ? quantityInput.value
        : 1;


    return addVariant(
      variantId,
      quantity
    );

  }


  /* =========================================================
     Wishlist Page Helpers
  ========================================================= */

  function normalizeImageUrl(
    url
  ) {

    if (!url) {
      return '';
    }


    if (
      url.startsWith('//')
    ) {

      return `https:${url}`;

    }


    return url;
  }


  function formatMoney(
    cents
  ) {

    const amount =
      Number(
        cents || 0
      ) / 100;


    const currency =
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
        ? window.Shopify.currency.active
        : 'USD';


    try {

      return new Intl.NumberFormat(
        document.documentElement.lang ||
        'en-US',
        {

          style:
            'currency',

          currency:
            currency

        }
      ).format(
        amount
      );

    } catch (error) {

      return `$${amount.toFixed(2)}`;

    }

  }


  async function getProduct(
    handle
  ) {

    const response =
      await fetch(
        `${rootUrl()}products/${encodeURIComponent(handle)}.js`,
        {

          headers: {
            Accept:
              'application/json'
          },

          credentials:
            'same-origin'

        }
      );


    if (!response.ok) {

      throw new Error(
        `Unable to load ${handle}`
      );

    }


    return await response.json();

  }


  function firstAvailableVariant(
    product
  ) {

    if (
      !product ||
      !Array.isArray(
        product.variants
      )
    ) {

      return null;

    }


    return (
      product.variants.find(
        variant =>
          variant.available
      ) ||
      product.variants[0] ||
      null
    );

  }


  /* =========================================================
     Public API
  ========================================================= */

  window.RawAuraCommerce = {

    getWishlist,
    saveWishlist,
    isWishlisted,
    addWishlist,
    removeWishlist,
    toggleWishlist,
    syncWishlistButtons,

    getCart,
    addVariant,
    addForm,

    getProduct,
    firstAvailableVariant,
    normalizeImageUrl,
    formatMoney,

    rootUrl

  };


  /* =========================================================
     Init
  ========================================================= */

  function initialize() {

    syncWishlistButtons();


    /*
     * 页面加载时也确保
     * 没有残留 cart bubble 动画。
     */

    removeCartBubbleAnimations();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once:
          true
      }
    );

  } else {

    initialize();

  }


  /* =========================================================
     Wishlist 多标签页同步
  ========================================================= */

  window.addEventListener(
    'storage',
    event => {

      if (
        event.key !==
        WISHLIST_KEY
      ) {
        return;
      }


      syncWishlistButtons();


      const wishlist =
        getWishlist();


      window.dispatchEvent(
        new CustomEvent(
          'raw-aura:wishlist-changed',
          {
            detail: {

              items:
                wishlist,

              count:
                wishlist.length

            }
          }
        )
      );

    }
  );

})();